module.exports = __webpack_public_path__ + "static/media/PA-Icon-Telefon-pos.6bb37581.svg";